export function insertItem(cache: string[], key: string) {
  const oldCache = Array.from(cache);
  oldCache.reverse();

  const nextCache = new Set<string>();
  for (const entry of oldCache) {
    nextCache.add(entry);
  }

  nextCache.delete(key);
  nextCache.add(key);

  const reorderedCache = Array.from(nextCache);
  reorderedCache.reverse();

  return reorderedCache;
}
